export const CREATE_GROUP = `
  mutation createGroup($input: CreateGroupInput!, $tenant_id: Int!) {
    createGroup(input: $input, tenant_id: $tenant_id) {
      __typename

      ... on Group {
        id
        name
        program_id
        program_variant_id
        program_variant {
          id
          name
          scope
        }
        load_date
        active
        close_date
        include
        sponsored
        tier
        budget
        vistage20_id
        vcg_id
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_GROUP = `
  mutation updateGroup($input: UpdateGroupInput!, $tenant_id: Int!) {
    updateGroup(input: $input, tenant_id: $tenant_id) {
      __typename

      ... on Group {
        id
        name
        program_id
        program_variant_id
        program_variant {
          id
          name
          scope
        }
        load_date
        active
        close_date
        include
        sponsored
        tier
        budget
        vistage20_id
        vcg_id
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_GROUP = `
  mutation deleteGroup($id: Int!, $tenant_id: Int!) {
    deleteGroup(id: $id, tenant_id: $tenant_id) {
      __typename

      ... on Group {
        id
        dts
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_ALL_GROUPS_BUDGET = `
  mutation updateAllGroupsBudget($tenant_id: Int!) {
    updateAllGroupsBudget(tenant_id: $tenant_id) {
      __typename

      ... on Count {
        count
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const ASSIGN_CHAIR_TO_GROUP = `
  mutation assignChairToGroup($input: AssignGroupChairInput!, $tenant_id: Int!) {
    assignChairToGroup(input: $input, tenant_id: $tenant_id) {
      __typename

      ... on GroupChair {
        id
        group_id
        chair_id
        date_from
        date_to
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_GROUP_CHAIR_ASSIGNMENT = `
  mutation updateGroupChairAssignment($input: UpdateGroupChairInput!, $tenant_id: Int!) {
    updateGroupChairAssignment(input: $input, tenant_id: $tenant_id) {
      __typename

      ... on GroupChair {
        id
        group_id
        chair_id
        date_from
        date_to
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
